import { timezoneChoiceForUpdate } from '@mfw/common';

type LocaleSettings = {
  locale?: null | string;
  ownLocale?: null | string;
};

/**
 * The language an account actually uses. `settings.locale` from the user mapper
 * reads en-US for an account with none, which is every new one: never prefill or
 * show that, or a form saves English for someone looking at their tenant's Serbian.
 */
export const accountLocale = (
  settings: LocaleSettings | null | undefined,
  tenantLocale: null | string | undefined,
) => settings?.ownLocale || tenantLocale || settings?.locale || undefined;

/**
 * Same rule as the time zone: an untouched inherited language must not become the
 * account's own on a save that was about something else, or a later change of the
 * tenant's language stops reaching it.
 */
export const localeChoiceForUpdate = ({
  ownLocale,
  prefilled,
  submitted,
}: {
  ownLocale?: null | string;
  prefilled: string;
  submitted?: null | string;
}) =>
  timezoneChoiceForUpdate({ existingChoice: ownLocale, prefilled, submitted });
